(() => {
  const normalizeHost = (host) => host.toLowerCase().replace(/\.$/, '');
  const currentHost = normalizeHost(window.location.hostname);

  function updateLink(link) {
    let url;
    try {
      url = new URL(link.getAttribute('href'), document.baseURI);
    } catch {
      return;
    }
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return;

    const host = normalizeHost(url.hostname);
    const internal = host === currentHost || host === 'xteink.com' || host.endsWith('.xteink.com');
    if (internal) {
      if (link.hasAttribute('target')) link.removeAttribute('target');
      if (link.relList.contains('nofollow')) link.relList.remove('nofollow');
      return;
    }

    if (link.getAttribute('target') !== '_blank') link.setAttribute('target', '_blank');
    for (const token of ['nofollow', 'noopener', 'noreferrer']) {
      if (!link.relList.contains(token)) link.relList.add(token);
    }
  }

  function updateTree(root) {
    if (root.matches?.('a[href], area[href]')) updateLink(root);
    root.querySelectorAll?.('a[href], area[href]').forEach(updateLink);
  }

  updateTree(document);
  new MutationObserver((records) => {
    for (const record of records) {
      if (record.type === 'attributes') {
        if (record.target.matches('a[href], area[href]')) updateLink(record.target);
      } else {
        record.addedNodes.forEach(updateTree);
      }
    }
  }).observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['href', 'target', 'rel'],
  });
})();
